import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';
import {
  HdsTextBody,
  HdsCopySnippet,
  HdsFormCheckboxField,
} from '@hashicorp/design-system-components/components';
import { boxMargin } from 'core/modifiers';
import {
  FieldViolation,
  FormValidationError,
} from 'core/utils/form-validation';

/**
 *
 *
 * This component is primarily responsible for:
 *  1. Displaying the user's MFA recovery code
 *  2. Confirming that the user has recorded their MFA recovery code
 *  3. Closing the modal & displaying success flashMessage
 *
 * a success flashMessage indicating successful MFA enablement. If not passed in, the default value of `false` will be used instead.
 *
 */
export default class ManageMfaEnableRecoveryCode extends Component {
  @service intl;
  @tracked error = '';

  validateForm = (evt) => {
    evt.preventDefault();
    const validationError = new FormValidationError(
      this.intl.t(
        'components.page.account-settings.security.mfaModal.step3.error'
      )
    );
    if (this.args.downloadedRecoveryCode === false) {
      validationError.details.push(
        new FieldViolation(
          this.intl.t(
            'components.page.account-settings.security.mfaModal.step3.error'
          ),
          'recovery-code-checkbox'
        )
      );
      if (validationError.details.length) {
        this.error = validationError.details[0].field_violations[0].description;
        throw validationError;
      }
    }
    this.args.handleMFASuccess();
  };

  <template>
    <HdsTextBody @tag="p">
      {{t "components.page.account-settings.security.mfaModal.step3.body"}}
    </HdsTextBody>
    <div {{boxMargin "md 0 lg"}}>
      <HdsCopySnippet
        @textToCopy={{@mfaRecoveryCode}}
        data-test-mfa-recoveryCode
      />
    </div>
    <form id={{@formId}} {{on "submit" this.validateForm}}>
      <HdsFormCheckboxField
        @id="recovery-code-checkbox"
        {{on "change" @onCheck}}
        checked={{@downloadedRecoveryCode}}
        data-test-mfa-confirm-recovery-code-checkbox
        as |F|
      >
        <F.Label>
          {{t
            "components.page.account-settings.security.mfaModal.step3.recoveryCodeConfirmation"
          }}
        </F.Label>
        {{#if (and this.error (not @downloadedRecoveryCode))}}
          <F.Error data-test-mfa-recovery-code-error>
            {{this.error}}
          </F.Error>
        {{/if}}
      </HdsFormCheckboxField>
    </form>
  </template>
}
